import { brandConfig } from "@/config/brand";

export const COLORS = {
  button: {
    primaryBackground:
      brandConfig.button.surface === "gradient"
        ? brandConfig.palette.gradient
        : brandConfig.button.backgroundColor,
    primaryColor: brandConfig.button.color,
    primaryHoverBackground:
      brandConfig.button.surface === "gradient"
        ? brandConfig.palette.gradient
        : brandConfig.button.hoverBackgroundColor,
    primaryHoverColor:
      brandConfig.button.surface === "gradient"
        ? brandConfig.button.color
        : brandConfig.button.hoverColor,
    secondaryBackground: brandConfig.button.secondary.backgroundColor,
    secondaryColor: brandConfig.button.secondary.color,
    secondaryBorderColor: brandConfig.button.secondary.borderColor,
    secondaryHoverBackground: brandConfig.button.secondary.hoverBackgroundColor,
    secondaryHoverColor: brandConfig.button.secondary.hoverColor,
    secondaryHoverBorderColor: brandConfig.button.secondary.hoverBorderColor,
    disabledBackground: brandConfig.button.disabled.backgroundColor,
    disabledColor: brandConfig.button.disabled.color,
  },
  common: {
    white: brandConfig.colors.common.white,
    black: brandConfig.colors.common.black,
    transparent: brandConfig.colors.common.transparent,
  },
  brand: {
    primary: brandConfig.palette.primary,
    secondary: brandConfig.colors.brand.secondary,
    gradientStart: brandConfig.colors.brand.gradientStart,
    gradientMiddle: brandConfig.colors.brand.gradientMiddle,
    gradientAccent: brandConfig.colors.brand.gradientAccent,
    gradientWarm: brandConfig.colors.brand.gradientWarm,
    gradientEnd: brandConfig.colors.brand.gradientEnd,
    accentBronze: brandConfig.colors.brand.accentBronze,
    accentCritical: brandConfig.colors.brand.accentCritical,
    accentCriticalStrong: brandConfig.colors.brand.accentCriticalStrong,
    logoFill: brandConfig.palette.logoFill,
    creditsAccent: brandConfig.colors.brand.creditsAccent,
    creditsIcon: brandConfig.colors.brand.creditsIcon,
    creditsGradientStart: brandConfig.colors.brand.creditsGradientStart,
    creditsGradientMid: brandConfig.colors.brand.creditsGradientMid,
    creditsGradientEnd: brandConfig.colors.brand.creditsGradientEnd,
  },
  background: {
    bodyDefault: brandConfig.palette.bodyBackground,
    appSecondary: brandConfig.colors.background.appSecondary,
    sheetPrimary: brandConfig.palette.sheetBackground,
    cardPrimary: brandConfig.palette.cardPrimary,
    cardSurface: brandConfig.palette.cardSurface,
    upcomingChip: brandConfig.palette.upcomingChipBackground,
    memberSecondaryCard: brandConfig.member.secondaryCardBackground,
    memberHeader: brandConfig.member.headerBackground,
    memberCreditsHeader: brandConfig.member.creditsPage.headerBackground,
    memberQrCard: brandConfig.member.qrSection.cardBackground,
    memberQrIconBackground: brandConfig.member.qrSection.iconBackground,
    memberGoalSettingCard: brandConfig.member.goalSetting.cardBackground,
    memberGoalSettingDateActive: brandConfig.member.goalSetting.dateActiveBackground,
    memberGoalSettingDateInactive: brandConfig.member.goalSetting.dateInactiveBackground,
    dateButtonSelected: brandConfig.palette.tabActiveColor,
    datePickerBackground: brandConfig.palette.datePickerBackground,
    selectOptionBackground: brandConfig.palette.selectOptionBackground,
    surfaceMuted: brandConfig.palette.cardSurface,
    filterActive: brandConfig.palette.filterActiveBg,
    filterInactive: brandConfig.palette.filterInactiveBg,
    trainerFilterActive: brandConfig.palette.trainerFilterActiveBg,
    trainerFilterActiveHover: brandConfig.palette.trainerFilterActiveHoverBg,
    trainerFilterInactive: brandConfig.palette.trainerFilterInactiveBg,
    trainerFilterInactiveHover: brandConfig.palette.trainerFilterInactiveHoverBg,
    stepperActive: brandConfig.palette.stepperActive,
    stepperInactive: brandConfig.palette.stepperInactive,
    pagePrimary: brandConfig.colors.background.pagePrimary,
    surfaceSubtle: brandConfig.colors.background.surfaceSubtle,
    fieldPrimary: brandConfig.colors.background.fieldPrimary,
    feedbackSuccess: brandConfig.colors.background.feedbackSuccess,
    feedbackWarning: brandConfig.colors.background.feedbackWarning,
    feedbackNeutral: brandConfig.colors.background.feedbackNeutral,
    feedbackFreeze: brandConfig.colors.background.feedbackFreeze,
    accentMuted: brandConfig.palette.accentActive,
    fab: brandConfig.palette.fabBackground,
    fabHover: brandConfig.palette.fabBackgroundHover,
  },
  text: {
    sheetPrimary: brandConfig.palette.sheetText,
    onDarkPrimary: brandConfig.palette.cardText,
    cardTitle: brandConfig.palette.cardTitle,
    onDarkSecondary: brandConfig.palette.cardTextMuted,
    onDarkMuted: brandConfig.palette.cardTextDim,
    scheduleSectionMonth: brandConfig.palette.scheduleSectionMonth,
    dateButtonSelected: brandConfig.palette.dateButtonSelectedText,
    dateButtonInactive: brandConfig.palette.tabInactiveColor,
    tabActive: brandConfig.palette.tabActiveColor,
    tabInactive: brandConfig.palette.tabInactiveColor,
    filterActive: brandConfig.palette.filterActiveColor,
    filterInactive: brandConfig.palette.filterInactiveColor,
    trainerFilterActive: brandConfig.palette.trainerFilterActiveColor,
    trainerFilterInactive: brandConfig.palette.trainerFilterInactiveColor,
    dialogPrimary: brandConfig.palette.dialogText,
    dialogMuted: brandConfig.palette.dialogTextMuted,
    memberEmptyState: brandConfig.member.emptyStateText,
    memberHeaderPrimary: brandConfig.member.headerPrimaryText,
    memberHeaderSecondary: brandConfig.member.headerSecondaryText,
    memberSectionTitle: brandConfig.member.sectionTitleColor,
    memberCreditsHeader: brandConfig.member.creditsPage.headerText,
    memberQrLabel: brandConfig.member.qrSection.labelColor,
    memberCreditsMonth: brandConfig.member.creditsPage.monthText,
    memberCreditsTransactionDate: brandConfig.member.creditsPage.transactionDate,
    memberGoalSettingCardTitle: brandConfig.member.goalSetting.cardTitle,
    memberGoalSettingCardText: brandConfig.member.goalSetting.cardText,
    memberGoalSettingCardMuted: brandConfig.member.goalSetting.cardMutedText,
    memberGoalSettingCardAction: brandConfig.member.goalSetting.cardActionText,
    memberGoalSettingDateActive: brandConfig.member.goalSetting.dateActiveText,
    memberGoalSettingDateInactive: brandConfig.member.goalSetting.dateInactiveText,
    readMoreButton: brandConfig.palette.readMoreButtonColor,
    facilityUploadSlipTitle: brandConfig.facility.booking.paymentSlip.titleColor,
    onDarkPlaceholder: brandConfig.colors.text.onDarkPlaceholder,
    pagePrimary: brandConfig.palette.textPrimary,
    pageSecondary: brandConfig.palette.textSecondary,
    pageMuted: brandConfig.palette.pageTextMuted,
    onLightSecondary: brandConfig.colors.text.onLightSecondary,
    primary: brandConfig.colors.text.primary,
    primaryAlt: brandConfig.colors.text.primaryAlt,
    primaryStrong: brandConfig.colors.text.primaryStrong,
    tertiary: brandConfig.colors.text.tertiary,
    tertiaryAlt: brandConfig.colors.text.tertiaryAlt,
    disabled: brandConfig.colors.text.disabled,
    emphasis: brandConfig.colors.text.emphasis,
    disabledOnLight: brandConfig.colors.text.disabledOnLight,
  },
  border: {
    secondary: brandConfig.colors.border.secondary,
    divider: brandConfig.colors.border.divider,
    cardDivider: brandConfig.palette.cardDivider,
    strong: brandConfig.colors.border.strong,
    muted: brandConfig.colors.border.muted,
    neutral: brandConfig.colors.border.neutral,
    iconSurface: brandConfig.colors.border.iconSurface,
    tabActive: brandConfig.palette.accentActive,
    memberSectionDivider: brandConfig.member.sectionDividerColor,
    memberCreditsTransactionDivider: brandConfig.member.creditsPage.transactionDivider,
    memberGoalSettingDateActive: brandConfig.member.goalSetting.dateActiveBorder,
    memberGoalSettingDateInactive: brandConfig.member.goalSetting.dateInactiveBorder,
    memberGoalSettingCardDivider: brandConfig.member.goalSetting.cardDivider,
  },
  state: {
    error: brandConfig.colors.state.error,
    errorLight: brandConfig.palette.errorLight,
    success: brandConfig.colors.state.success,
    successBright: brandConfig.colors.state.successBright,
    warning: brandConfig.colors.state.warning,
    warningAlt: brandConfig.colors.state.warningAlt,
    neutral: brandConfig.colors.state.neutral,
    freeze: brandConfig.colors.state.freeze,
  },
  overlay: {
    disabled: brandConfig.colors.overlay.disabled,
    video: brandConfig.colors.overlay.video,
    videoEnd: brandConfig.colors.overlay.videoEnd,
    onDarkSoft: brandConfig.colors.overlay.onDarkSoft,
    onDarkDisabled: brandConfig.colors.overlay.onDarkDisabled,
    mutedLight: brandConfig.colors.overlay.mutedLight,
  },
  icon: {
    badgeBackground: brandConfig.colors.icon.badgeBackground,
    badgeForeground: brandConfig.colors.icon.badgeForeground,
    poolForeground: brandConfig.colors.icon.poolForeground,
    targetForeground: brandConfig.colors.icon.targetForeground,
    emptyState: brandConfig.palette.emptyStateIconColor,
    reservationDateRange: brandConfig.palette.reservationDateRangeIcon,
    memberCreditsFilter: brandConfig.member.creditsPage.filterIcon,
    memberQrIcon: brandConfig.member.qrSection.iconColor,
    memberGoalSettingBadgeBackground: brandConfig.member.goalSetting.iconBackground,
    memberGoalSettingBadgeForeground: brandConfig.member.goalSetting.iconForeground,
    memberGoalSettingTarget: brandConfig.member.goalSetting.targetIcon,
    memberGoalSettingChartLine: brandConfig.member.goalSetting.chartLine,
    memberGoalSettingChartLabel: brandConfig.member.goalSetting.chartLabel,
    memberGoalSettingChartGrid: brandConfig.member.goalSetting.chartGrid,
    memberGoalSettingSectionAccent: brandConfig.member.goalSetting.sectionAccent,
  },
};

export const GRADIENTS = {
  primary: brandConfig.palette.gradient,
  authBackground: brandConfig.palette.loginBackground,
  videoOverlay: brandConfig.gradients.videoOverlay,
};

export const SHADOWS = {
  bottomSheet: brandConfig.shadows.bottomSheet,
  cardDark: brandConfig.shadows.card,
  cardSubtle: brandConfig.shadows.cardSubtle,
  button: brandConfig.shadows.button,
  buttonHover: brandConfig.shadows.buttonHover,
  dialog: brandConfig.shadows.dialog,
  dialogHover: brandConfig.shadows.dialogHover,
  videoPlay: brandConfig.shadows.videoPlay,
};
